import React from 'react';
import { string, shape } from 'prop-types';
import { useBrandingData } from './DataProviders';
import { makeStyles } from '@material-ui/core/styles';

import SocialMediaLink from '../components/SocialMediaLink';


export default function SocialMediaGrid({ classes = {} }) {
  const { socialMedia = [], toggles: { show_social_media } = {} } = useBrandingData();
  const validLinks = socialMedia.filter( ({ handle, url }) => (handle || url) );

  if( show_social_media === false || validLinks.length === 0 ) {
    return null;
  }

  return (
    <div className={classes.root}>
      { validLinks.map( link => (
        <SocialMediaLink
          key={link.type}
          url={link.handle || link.url}
          type={link.type}
          classes={{ root: classes.link, icon: classes.linkIcon }}
        />
      ))}
    </div>
  );
}

SocialMediaGrid.propTypes = {
  classes: shape({
    root: string,
    link: string,
    linkIcon: string
  })
};

export function makeSocialMediaGridStyles(styles) {
  return makeStyles( theme => {
    const styleOverrides = styles(theme);
    return {
      ...styleOverrides, // for any toplevel class/styles that we don't need defaults for
      root: {
        display: 'flex',
        ...styleOverrides.root
      },
      link: {
        '&:last-child': {
          paddingRight: '0'
        },
        ...styleOverrides.link
      },
      linkIcon: {
        verticalAlign: 'middle',
        ...styleOverrides.linkIcon
      }
    };
  }, { name: 'SocialStyles' } );
}


